import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Card, CardBody, CardHeader } from '@heroui/react';

const Security = () => {
  return (
    <div className="flex min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 justify-center items-center p-4">
      <Card className="w-full p-8 md:p-12 rounded-lg shadow-2xl max-w-2xl bg-white/95 backdrop-blur-sm">
        <CardHeader className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-800">Security Policy</h2>
        </CardHeader>
        <CardBody>
          <div className="prose max-w-none">
            <ReactMarkdown>
              {`This security policy describes the security measures we take to protect your information. We are committed to ensuring the security of your information and protecting it from unauthorized access, use, or disclosure.

## Data Security
We do not store any of your data locally. All data is processed locally on your device. Data sent to LLM's is encrypted using industry-standard encryption protocols to protect it from unauthorized access.

## Personal Information
Personal information is only used for logging in and logging out. We do not sell your personal information to third parties. We implement a variety of security measures to protect your personal information from unauthorized access, use, or disclosure. These measures include:
- Encryption of personal information
- Use of strong passwords
- Regular security audits

## Your Responsibilities
You are responsible for protecting your own personal information. You can do this by:
- Using a strong password
- Keeping your password confidential
- Logging out of our application when you are finished using it

## Contact Us
If you have any questions about this security policy, please contact us.`}
            </ReactMarkdown>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default Security;
